export default "__VITE_ASSET__8WFVHa3X__"